export default "__VITE_ASSET__SvzJ$Ei2__"